import { useRequest } from 'ahooks';
import { useMemo } from 'react';
import { getIntegrationJdCallback } from 'src/api/integration/jd/callback';
import { message } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

interface UseJdShopAuthenticationProps {
    onFinally?: () => void;
}

export const useJdShopAuthentication = (props: UseJdShopAuthenticationProps) => {
    const { onFinally } = props;

    const urlSerchParams = new URLSearchParams(window.location.search);
    const code = urlSerchParams.get('code');
    const state = urlSerchParams.get('state');

    const isAuth = useMemo(() => !!state && !!code, [state, code]);

    const { loading } = useRequest(
        () =>
            getIntegrationJdCallback({
                params: {
                    code: code!,
                    state: state!,
                },
            }),
        {
            ready: isAuth,
            onSuccess: () => {
                message.success(/* 授权成功 */UdeskLocales['current'].pages.systemIntegration.jdShop.hooks.index.authorizationSucceeded);
            },
            onFinally: () => {
                onFinally?.();
            },
        }
    );

    return {
        isAuth,
        loading,
    };
};
